






































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import CustomTableScrollWrap from "@/components/custom/CustomTableScrollWrap/index.vue";
import { obj2Arr } from "@root/lib/utils";
import { TableExpandWithAccordionDecorator } from "@root/utils/modules/wtRecord/decorator";

const common = namespace("common");
const scan = namespace("scan");
const root = namespace("root");
@Component({
  components: { CustomTableScrollWrap }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
@TableExpandWithAccordionDecorator()
export default class InventoryFlow extends Vue {
  @common.Action queryDataDictionaryListLang;
  @scan.Action querySupplierScanRecord;
  @scan.Action supplierScanRecordQuery;
  @scan.Action querySupplierScanRecordDetail;
  @scan.Action getAttr;
  @scan.Action exportSupplierScanRecord;
  @scan.Action exportSupplierScanRecordDetail;
  @scan.Action querySupplierScanRecordCommerce;
  @scan.Action commerceSupplierScanRecordDetailExport;

  @root.State ddCodes;
  private patternDataOptions = [];
  private specificationDataOptions = [];
  memberCode: any = "";
  data() {
    return {
      obj2Arr
    };
  }

  private dataList = [];
  private activeName: any = null;
  private tableSearchForm = {};
  private isShowExportDialog = false;

  private form = {
    date: "",
    tyreCode: "",
    k1Code: "",
    specifications: "",
    pattern: "",
    recordCode: "",
    status: null,
    optype: null
  };

  get flowTypeOptions() {
    return this.ddCodes.WT_INVENTORY_FLOW_TYPE_MAP;
  }

  get scanTypeOptions() {
    return this.ddCodes.INOUT_INVENTORY_STATUS_MAP;
  }

  get flowTypeTabs() {
    const firstList = [
      {
        value: null,
        label: "全部"
      }
    ];
    // if (!this.flowTypeOptions) return firstList;

    let opts: any = this.ddCodes.WT_INVENTORY_FLOW_TYPE_KONE || [];
    if (this.memberCode === "CKH0021113") {
      opts = this.ddCodes.WT_INVENTORY_FLOW_TYPE || [];
    }
    // let list = [
    //   "K1扫码出库",
    //   "佳通快递出库",
    //   "K2退货入库",
    //   "佳通ERP入库",
    //   "佳通虚拟入库",
    //   "K1盘点入库"
    // ];
    // let list = ["K1扫码出库","佳通快递出库","K2退货入库","佳通ERP入库"]
    // let newOpts = list.map(v => {
    //   return opts.find(k => k.label === v);
    // });
    const res = firstList.concat(opts as any);
    return res;
  }

  get scanTypeTabs() {
    const firstList = [
      {
        value: null,
        label: "全部"
      }
    ];
    if (!this.scanTypeOptions) return firstList;
    const opts = this.ddCodes.INOUT_INVENTORY_STATUS_MAP;
    let list = [];
    for (const key in opts) {
      list.push({ value: Number(key), label: opts[key] });
    }
    const res = firstList.concat(list as any);
    return res;
  }

  get orderListComputed() {
    return this.dataList;
  }

  get isEcommerceType() {
    let str: any = this.activeName
      ? this.activeName.toString()
      : this.activeName;
    return ["7", "8"].includes(str);
  }
  get isEcommerceTypeExportCode() {
    let str: any = this.activeName
      ? this.activeName.toString()
      : this.activeName;
    if (str == "8") {
      return "22";
    } else {
      return "70";
    }
  }

  async mounted() {
    this.memberCode = localStorage.getItem("memberCode");
    this.getAttrApi();
    this.$dd
      .register([
        "WT_BRAND",
        "WT_INVENTORY_FLOW_TYPE_KONE",
        "INOUT_INVENTORY_STATUS",
        "WT_INVENTORY_FLOW_TYPE"
      ])
      .query();
    setTimeout(() => {
      this.getData();
    }, 500);
  }
  get searchParams() {
    const {
      date,
      tyreCode,
      k1Code,
      specifications,
      pattern,
      recordCode,
      status,
      optype
    } = this.form;
    const { activeName } = this;
    let input = {
      tyreCode,
      orgCode: k1Code,
      recordType: optype || "", // parseInt(this.activeName)
      startTime: null,
      endTime: null,
      updateStartTime: "",
      updateEndTime: "",
      specifications,
      status: status || null,
      pattern,
      recordCode
      // 1:扫码出库 2：ERP导入 3：盘库 4：退货入库
    };
    if (date && date.length > 0) {
      input["startTime"] = date[0];
      input["endTime"] = date[1];
    }
    return input;
  }

  @loadingCatch
  async getData(isTab = "") {
    await this.timeLimitFn();
    (this as any).expandKeys = [];
    if (this.form.optype != this.activeName) {
      (this as any).currentPage = 1;
    }
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };
    if (isTab) {
      this.form.optype = this.activeName === "null" ? null : this.activeName;
    } else {
      this.activeName = this.form.optype;
    }
    const { searchParams } = this;
    try {
      let searchForm = {
        input: { ...searchParams, systemSource: "k-one" },
        pageInput
      };
      this.tableSearchForm = searchForm;
      // let { total, list } = await this.supplierScanRecordQuery(searchForm);
      let res: any = {};
      if (this.isEcommerceType) {
        res = await this.querySupplierScanRecordCommerce({
          ...searchParams,
          systemSource: "k-one",
          ...pageInput
        });
        this.tableSearchForm = { ...searchParams, systemSource: "k-one" };
      } else {
        res = await this.querySupplierScanRecordDetail(searchForm);
      }
      let { total, list } = res;
      this.dataList = list;
      (this as any).total = total;
    } catch (err) {
      console.error(err);
    }
  }

  async getAttrApi() {
    const list = await this.getAttr({
      codeList: ["_pattern", "_specification"], // _hubDiameter 尺寸
      orgCode: "default"
    });
    if (list) {
      this.patternDataOptions = list[0] && list[0].value;
      this.specificationDataOptions = list[1] && list[1].value;
      this.patternDataOptions = this.patternDataOptions.map(v => {
        return { label: v.label, value: v.label };
      });
      this.specificationDataOptions = this.specificationDataOptions.map(v => {
        return { label: v.label, value: v.label };
      });
    }
  }
  async exportExcelFn() {
    await this.timeLimitFn();
    if (this.isEcommerceType) {
      await this.commerceSupplierScanRecordDetailExport(this.tableSearchForm);
    } else {
      // return await this.exportSupplierScanRecord(this.tableSearchForm);
      return await this.exportSupplierScanRecordDetail(this.tableSearchForm);
    }
  }
  handleClick(val) {
    this.activeName = val;
    (this as any).currentPage = 1;
    this.getData("tab");
  }
  async timeLimitFn() {
    return new Promise((resolve, reject) => {
      const { searchParams: input } = this;
      const {
        tyreCode,
        recordCode,
        startTime,
        endTime,
        updateStartTime,
        updateEndTime
      } = input;
      if (
        !(tyreCode || recordCode) &&
        !startTime &&
        !endTime &&
        !updateStartTime &&
        !updateEndTime
      ) {
        this.$message.warning("请选择时间！");
        reject(false);
        return false;
      } else {
        resolve(true);
        return true;
      }
    });
  }
  setCount(row) {
    let getTimes =
      new Date(row.shippingTime).getTime() - new Date("2019-1-1").getTime();
    let recordType = row.recordType.toString();
    let status = row.status.toString();
    // recordType: 1--K1批发出库、4--K2退货入库、5--佳通快递出库、7--K1电商出库、8--K1调拨入库
    // statu: 1--已生效、2--已退回
    if (getTimes >= 0) {
      if (
        (recordType === "1" || recordType === "5" || recordType === "7") &&
        status === "1"
      ) {
        return 1;
      }
      if (
        (recordType === "1" || recordType === "5" || recordType === "7") &&
        status === "2"
      ) {
        return -1;
      }
      if (recordType === "4" && status === "1") {
        return -1;
      }
    }
    return 0;
  }
}
